<template>
  <div class="relative">
    <label class="text-sm font-bold block dark:text-white">
      <slot name="label" />

      {{ label }}

      <span
        v-if="isRequired && showIsRequired"
        class="text-red"
      >
        *
      </span>
    </label>

    <textarea
      v-bind="$attrs"
      class="block w-full mt-1 rounded-lg p-4 placeholder-gray-250 focus:ring-0"
      :class="[classes, errorClasses]"
      :name="name"
      :value="modelValue"
      :placeholder="placeholder"
      :required="isRequired"
      :maxlength="maxLength"
      @input="(e) => { $emit('update:modelValue', e.target.value); inputLength = e.target.value.length}"
    />
    <span
      v-if="maxLength"
      class="absolute right-2 bottom-1 text-xs text-gray-250"
    >
      {{ inputLength }}/{{ maxLength }}
    </span>

    <span
      v-if="form.errors && form.errors[name]"
      class="block text-red-500 text-sm mt-1"
    >
      * {{ form.errors[name] }}
    </span>
  </div>
</template>

<script>
import Field from './Field';

export default {
  mixins: [Field],

  props: {
    maxLength: {
      type: Number,
      required: false,
      default: null,
    },

    showIsRequired: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      inputLength: 0,
    };
  },
};
</script>
